export const WideStrip = () => {
  return (
    <section
      className="w-full h-44 relative overflow-hidden border-y border-slate-300 bg-slate-900"
      data-testid="integrity-strip"
    >
      <img
        src="https://images.unsplash.com/photo-1627372129933-9abc19b91f21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHx0ZWNoJTIwbGFib3JhdG9yeSUyMGRlc2slMjB0YWJsZXRzfGVufDB8fHx8MTc5MjMxMTczMHww&ixlib=rb-4.1.0&q=85"
        alt="Clean tech laboratory desk with tablets running mobile build tools"
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover kaje-drift"
      />
      <div className="absolute inset-0 flex items-center justify-center bg-slate-950/60 text-center px-6">
        <div>
          <span className="kaje-mono text-xs text-emerald-400 font-bold uppercase tracking-widest">
            Australian Business Verification
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-white mt-1">
            Direct Developer Integrity &amp; Clear Accountability
          </h3>
        </div>
      </div>
    </section>
  );
};
